import React from "react";

function FloatingIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 341.8 246.85"
            width={20}
            fill="currentColor"
        >
            <g data-name="Layer 2">
                <g data-name="Layer 1">
                    <g data-name="Groupe 139">
                        <path
                            d="M251.58 20.89a24.85 24.85 0 0124.84 24.84v113.78a24.85 24.85 0 01-24.84 24.83h-206a24.85 24.85 0 01-24.68-24.83V45.57a24.85 24.85 0 0124.67-24.68h205.94m0-20.89H45.57A45.57 45.57 0 000 45.57v113.94a45.57 45.57 0 0045.57 45.57h205.94a45.57 45.57 0 0045.57-45.57V45.57A45.57 45.57 0 00251.51 0z"
                            data-name="Tracé 73"
                        ></path>
                    </g>
                    <rect
                        width="284.83"
                        height="189.89"
                        x="56.97"
                        y="56.97"
                        data-name="Rectangle 39"
                        rx="37.98"
                    ></rect>
                </g>
            </g>
        </svg>
    );
}

export default FloatingIcon;
